import React from "react";
import Layout from "./components/Layout";
import { AppProvider } from "./context/AppProvider";
import { ViewportProvider } from "../../components/ReactContext_Viewport";
import './legacyStyles.css';
import "./App.scss";

function App({ storybookState }) {
    return (
        <AppProvider storybookState={storybookState}>
            <ViewportProvider>
                <Layout />
            </ViewportProvider>
        </AppProvider>
    );
}

export default App;
